export default __webpack_public_path__ + "src/assets/icn-info.45ab25d28ae363aecb899b2085e91e23.svg";